export const Logo = ({ className = "h-9 w-auto" }) => (
  <img
    src="/assets/logo_full.png"
    alt="SalesMoat — Sales IP. Engineered."
    className={className}
    draggable="false"
  />
);
